import React, {useEffect, useState} from "react";
import ValueInputField from "../Elements/ValueInputField";
import Label from "../Elements/Label";
import InputTypeHidden from "../Elements/InputTypeHidden";
import PlzInputField from "../Elements/PlzInputField";


const ErdgasPrivat = (props) => {
    const values = {50:5000,100:12000,150:18000,180:20000};
    const threshold = 100000;

    const renderLabel = (entry) => {
        if(props.value === entry['1'])
            return <Label key={entry['0']} setValue={props.setValue} icon="haus" active={true} value={entry}/>
        return <Label key={entry['0']} setValue={props.setValue} icon="haus" value={entry}/>
    }

    useEffect(() => {
        props.setValue(values["150"]);
        props.setThreshold(threshold);
        props.setDisableButton(true);
    }, [])

    return <div className="gas">
        <p>
            <strong>Finden Sie hier Ihr passendes Erdgas-Produkt:</strong>
        </p>
        <div className="row row-small-gutters">
            <div className="col-sm-6">
                <PlzInputField setDisableButton={props.setDisableButton} name="postalCode" type="GAS" setErrorText={props.setErrorText} setShowError={props.setShowError} placeholder="Ihre PLZ"/>
            </div>
            <div className="col-sm-6">
                <ValueInputField name="consumption" setValue={props.setValue} value={props.value} placeholder="Jahresverbrauch (kWh)"/>
            </div>
            <InputTypeHidden name="customerType" value="PRIVATE"/>
            <InputTypeHidden name="mediaType" value="GAS"/>
        </div>
        <div className="select-gas">
            <p>Ihre Wohnfläche (m²)</p>
            <ul>
                {
                    Object.entries(values).map((entry) => {
                        return renderLabel(entry)
                    })
                }
            </ul>
        </div>
    </div>
}

export default ErdgasPrivat;